var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.2,
    height: 75.425,
    viewBox: "0 0 86.2 75.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-camera",
    "data-name": "Icon awesome-camera",
    d: "M86.2,21.106V69.594a8.083,8.083,0,0,1-8.081,8.081H8.081A8.083,8.083,0,0,1,0,69.594V21.106a8.083,8.083,0,0,1,8.081-8.081H22.9l2.071-5.539A8.07,8.07,0,0,1,32.527,2.25H53.656a8.07,8.07,0,0,1,7.559,5.236L63.3,13.025H78.119A8.083,8.083,0,0,1,86.2,21.106ZM63.3,45.35a20.2,20.2,0,1,0-20.2,20.2A20.219,20.219,0,0,0,63.3,45.35Zm-5.388,0A14.816,14.816,0,1,1,43.1,30.534,14.837,14.837,0,0,1,57.916,45.35Z",
    transform: "translate(0 -2.25)",
    fill: "#605858"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.bb373af38efdc62f20d8f3016e78ae88.svg";
export { ForwardRef as ReactComponent };